import { useUserAuthState } from "src/features/auth/UserAuthState";
import { API_BASE_URL } from "src/lib/config";
import { ListMerchantResponseItemModel } from "./models/ListMerchantResponseItemModel";
import { useHTTP, useHTTPQuery } from "shared/lib/http";

export const useMerchantList = () => {
	const { state } = useUserAuthState();
	const http = useHTTP(state.accessToken);

	return useHTTPQuery(["merchantList"], () => {
		return http<ListMerchantResponseItemModel[]>({
			method: "GET",
			url: `${API_BASE_URL}/admin/merchant/list`
		});
	});
};
